import MakrCharts from "./makrCharts";
import MakrEventCntCharts from "./makrEventCntCharts";
import MakrEventTimeCharts from "./makrEventTimeCharts";
import React from "react";
import { useHistory } from "react-router-dom";

// kendo
import { Grid, GridColumn, GridNoRecords, GridToolbar } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import { IntlProvider, LocalizationProvider, loadMessages } from "@progress/kendo-react-intl";
import { orderBy } from "@progress/kendo-data-query";

// service
import { numFormat } from "../../../../com/dataUtil";

// Css
// import './makr.css';

export const MakrDashboard = ({ styles, dataSource, searchClick, paging, sort, onPageChange, onSortChange, downloadExcel, loading }) => {
  const history = useHistory();

  // 이벤트-이력조회 이동 (전체)
  const goLogHistory = e => {
    history.push(
      "/mngt/analy/event/log?ensoTypeCodeNo=" +
        searchClick.ensoTypeCodeNo +
        "&rgnCode=" +
        searchClick.rgnCode +
        "&start=" +
        searchClick.start +
        "&end=" +
        searchClick.end,
    );
  };

  // 이벤트-이력조회 이동 (경고)
  const goLogWarnHistory = e => {
    history.push(
      "/mngt/analy/event/log?ensoTypeCodeNo=" +
        searchClick.ensoTypeCodeNo +
        "&rgnCode=" +
        searchClick.rgnCode +
        "&start=" +
        searchClick.start +
        "&end=" +
        searchClick.end +
        "&facilityState=7006",
    );
  };

  // 이벤트-이력조회 이동 (고장)
  const goLogErrHistory = e => {
    history.push(
      "/mngt/analy/event/log?ensoTypeCodeNo=" +
        searchClick.ensoTypeCodeNo +
        "&rgnCode=" +
        searchClick.rgnCode +
        "&start=" +
        searchClick.start +
        "&end=" +
        searchClick.end +
        "&facilityState=7007",
    );
  };

  const warnCell = data => {
    return <td>{numFormat(data.dataItem.warn)}</td>;
  };
  const errCell = data => {
    return <td>{numFormat(data.dataItem.err)}</td>;
  };
  const manaTmCell = data => {
    return <td>{numFormat(data.dataItem.manaTm)}</td>;
  };

  return (
    <>
      <div
        style={
          loading
            ? {
                opacity: 0.6,
                pointerEvents: "none",
              }
            : null
        }>
        <div className="makrBoard">
          <div title="클릭시 상세페이지로 이동합니다." id="test" className="makrBoardSub" onClick={goLogHistory}>
            <div>
              <span>총발생 신호</span>
              <br />
              <span className="makrBoardContent">
                <b>{dataSource.dashboard.ttl >= 0 ? numFormat(dataSource.dashboard.ttl) : 0}</b>

                <span>건</span>
              </span>
            </div>
          </div>
          <div title="클릭시 상세페이지로 이동합니다." className="makrBoardSub" onClick={goLogWarnHistory}>
            <div>
              <span>누적 경고 신호</span>
              <br />
              <span className="makrBoardContent">
                <b>{dataSource.dashboard.warn >= 0 ? numFormat(dataSource.dashboard.warn) : 0}</b>

                <span>건</span>
              </span>
            </div>
          </div>
          <div title="클릭시 상세페이지로 이동합니다." className="makrBoardSub" onClick={goLogErrHistory}>
            <div>
              <span>누적 고장 신호</span>
              <br />
              <span className="makrBoardContent">
                <b>{dataSource.dashboard.err >= 0 ? numFormat(dataSource.dashboard.err) : 0}</b>

                <span>건</span>
              </span>
            </div>
          </div>
          <div className="makrBoardSubManaTm">
            <div>
              <span>수동 조치시간</span>
              <br />
              <span className="makrBoardContent">
                <b>
                  {numFormat(dataSource.dashboard.manaTm)}
                  <span>분</span>
                </b>
              </span>
            </div>
          </div>
        </div>
        <div className="makrArticle">
          <div className="makrArticleSub">
            <div className="makrArticleSubTitle">
              <h3>제조사별 이벤트</h3>
            </div>
            <div className="makrArticleEngCharts">
              <div>
                <MakrEventCntCharts dataSource={dataSource} />
              </div>
              <div>
                <MakrEventTimeCharts dataSource={dataSource} />
              </div>
              <div>{/* <EnsoPieCharts chartTitle='조치소요시간' data={dataSource.eventContent} /> */}</div>
            </div>
          </div>
          <div className="makrArticleSub">
            <div className="makrArticleSubTitle">
              <h3>시간대별 경고/고장 상세정보</h3>

              <Button className={styles.makrExcelBtnClass} onClick={downloadExcel}>
                엑셀저장
              </Button>
            </div>
            <div className="makrArticleTimeCharts">
              <MakrCharts xCategories={dataSource.xCategories} warnData={dataSource.warnData} errData={dataSource.errData} />
            </div>
            <div className="makrArticleTimeGrid">
              <LocalizationProvider language="ko-KR">
                <IntlProvider locale="ko">
                  <Grid
                    className={styles.makrGrid}
                    style={{ height: "385px" }}
                    data={orderBy(dataSource.list, sort)}
                    total={dataSource.listTotal}
                    skip={paging.skip}
                    take={paging.take}
                    page={paging}
                    onPageChange={onPageChange}
                    sort={sort}
                    onSortChange={onSortChange}
                    sortable
                    pageable={{
                      type: "numeric",
                      pageSizes: [5, 10, 20, 50, 100],
                      previousNext: true,
                      buttonCount: 5,
                    }}>
                    <GridColumn field="makrTerm" title="제조사" />
                    <GridColumn field="meainTypeTerm" title="모델" />
                    <GridColumn field="warn" title="경고" cell={warnCell} />
                    <GridColumn field="err" title="고장" cell={errCell} />
                    <GridColumn field="manaTm" title="조치시간(분)" cell={manaTmCell} />
                  </Grid>
                </IntlProvider>
              </LocalizationProvider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MakrDashboard;
